/** Curated discovery defaults, not measured sales rankings. Live market data always wins. */
export const MARKET_FALLBACK_MAKES: Record<string, readonly string[]> = {
  CZE: [
    'SKODA',
    'VOLKSWAGEN',
    'HYUNDAI',
    'TOYOTA',
    'KIA',
    'FORD',
    'BMW',
    'MERCEDES_BENZ',
    'AUDI',
    'PEUGEOT',
    'RENAULT',
    'DACIA',
  ],
  SVK: [
    'SKODA',
    'KIA',
    'HYUNDAI',
    'VOLKSWAGEN',
    'TOYOTA',
    'PEUGEOT',
    'DACIA',
    'RENAULT',
    'FORD',
    'BMW',
    'MERCEDES_BENZ',
    'AUDI',
  ],
  DEU: [
    'VOLKSWAGEN',
    'MERCEDES_BENZ',
    'BMW',
    'AUDI',
    'SKODA',
    'OPEL',
    'FORD',
    'SEAT',
    'TOYOTA',
    'HYUNDAI',
    'RENAULT',
    'KIA',
  ],
  AUT: [
    'VOLKSWAGEN',
    'SKODA',
    'BMW',
    'AUDI',
    'MERCEDES_BENZ',
    'SEAT',
    'FORD',
    'HYUNDAI',
    'TOYOTA',
    'OPEL',
    'RENAULT',
    'KIA',
  ],
  POL: [
    'TOYOTA',
    'SKODA',
    'VOLKSWAGEN',
    'KIA',
    'HYUNDAI',
    'BMW',
    'MERCEDES_BENZ',
    'AUDI',
    'RENAULT',
    'DACIA',
    'OPEL',
    'FORD',
  ],
  FRA: [
    'RENAULT',
    'PEUGEOT',
    'DACIA',
    'CITROEN',
    'VOLKSWAGEN',
    'TOYOTA',
    'BMW',
    'MERCEDES_BENZ',
    'AUDI',
    'FORD',
    'HYUNDAI',
    'KIA',
  ],
  ITA: [
    'FIAT',
    'VOLKSWAGEN',
    'TOYOTA',
    'DACIA',
    'RENAULT',
    'PEUGEOT',
    'FORD',
    'JEEP',
    'CITROEN',
    'BMW',
    'AUDI',
    'MERCEDES_BENZ',
  ],
  ESP: [
    'SEAT',
    'TOYOTA',
    'VOLKSWAGEN',
    'RENAULT',
    'PEUGEOT',
    'HYUNDAI',
    'KIA',
    'DACIA',
    'CITROEN',
    'FORD',
    'NISSAN',
    'BMW',
  ],
  NLD: [
    'VOLKSWAGEN',
    'KIA',
    'TOYOTA',
    'PEUGEOT',
    'RENAULT',
    'SKODA',
    'HYUNDAI',
    'VOLVO',
    'BMW',
    'OPEL',
    'FORD',
    'TESLA',
  ],
  BEL: [
    'BMW',
    'VOLKSWAGEN',
    'PEUGEOT',
    'MERCEDES_BENZ',
    'AUDI',
    'RENAULT',
    'TOYOTA',
    'SKODA',
    'VOLVO',
    'OPEL',
    'KIA',
    'HYUNDAI',
  ],
  ROU: [
    'DACIA',
    'RENAULT',
    'SKODA',
    'VOLKSWAGEN',
    'TOYOTA',
    'HYUNDAI',
    'FORD',
    'KIA',
    'BMW',
    'MERCEDES_BENZ',
    'PEUGEOT',
    'OPEL',
  ],
  HUN: [
    'SUZUKI',
    'TOYOTA',
    'SKODA',
    'VOLKSWAGEN',
    'KIA',
    'FORD',
    'HYUNDAI',
    'OPEL',
    'DACIA',
    'BMW',
    'MERCEDES_BENZ',
    'RENAULT',
  ],
};

export const DEFAULT_FALLBACK_MAKES = [
  'VOLKSWAGEN',
  'TOYOTA',
  'SKODA',
  'RENAULT',
  'PEUGEOT',
  'BMW',
  'MERCEDES_BENZ',
  'AUDI',
  'DACIA',
  'KIA',
  'HYUNDAI',
  'FORD',
];
